<div class="main-content">
  <div class="container">
    <div class="row mb-4">

      <!--PENDING-->
      <div class="col-12 col-sm mb-2 mb-md-0">
        <mat-card class="dashboard-panel dashboard-panel--pending h-100">
          <mat-card-content class="">
            <div class="d-flex justify-content-center">
              <mat-spinner *ngIf="loading" [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'"></mat-spinner>
            </div>
            <div class="dashboard-panel-content d-flex align-items-center" *ngIf="!loading">
              <h1 class="col justify-content-between">
                Pending
                <span>{{count?.get(DomainDpStatus.PENDING)|| 0 | number}}</span>
                <small>out of {{totalCount || 0 | number}}</small>
              </h1>
              <div class="col d-sm-none d-md-inline dashboard-panel-chart">
                <cm-progress-circle [value]="count?.get(DomainDpStatus.PENDING)/(totalCount||1)" [fill]="'orange'"></cm-progress-circle>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!--APPROVED-->
      <div class="col-12 col-sm  mb-2 mb-md-0">
        <mat-card class="dashboard-panel dashboard-panel--approved h-100">
          <mat-card-content class="">
            <div class="d-flex justify-content-center">
              <mat-spinner *ngIf="loading" [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'"></mat-spinner>
            </div>
            <div class="dashboard-panel-content d-flex align-items-center" *ngIf="!loading">
              <h1 class="col justify-content-between">
                Approved
                <span>{{count?.get(DomainDpStatus.APPROVED)|| 0 | number}}</span>
                <small>out of {{totalCount || 0| number}}</small>
              </h1>
              <div class="col d-sm-none d-md-inline dashboard-panel-chart">
                <cm-progress-circle [value]="count?.get(DomainDpStatus.APPROVED)/(totalCount||1)" [fill]="'green'"></cm-progress-circle>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!--REJECTED-->
      <div class="col-12 col-sm  mb-2 mb-md-0">
        <mat-card class="dashboard-panel dashboard-panel--rejected h-100">
          <mat-card-content class="">
            <div class="d-flex justify-content-center">
              <mat-spinner *ngIf="loading" [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'"></mat-spinner>
            </div>
            <div class="dashboard-panel-content d-flex align-items-center" *ngIf="!loading">
              <h1 class="col justify-content-between">
                Rejected
                <span>{{count?.get(DomainDpStatus.REJECTED)|| 0 | number}}</span>
                <small>out of {{totalCount || 0| number}}</small>
              </h1>
              <div class="col d-sm-none d-md-inline dashboard-panel-chart">
                <cm-progress-circle [value]="count?.get(DomainDpStatus.REJECTED)/(totalCount||1)" [fill]="'red'"></cm-progress-circle>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="container-fluid container-xxl container--big">
    <div class="row">
      <div class="col">

        <div class="cm-card">

          <div class="cm-card-header d-flex justify-content-between align-items-center">

            <h3 class="cm-card-title m-0" *ngIf="!selection.selected.length">Sites</h3>

            <div class="ml-2 show-in-down" *ngIf="selection.selected.length">
              <button mat-raised-button color="primary" class="mr-1" (click)="approveSites(selection.selected)">Approve selected
              </button>
              <button mat-raised-button color="warn" (click)="rejectSites(selection.selected)">Rejected selected
              </button>
            </div>
            
            <div class="cm-card-header-info justify-content-end">
              <mat-form-field floatLabel="never" class="cm-card-header-search">
                <span matPrefix><i class="far fa-search"></i></span>
                <input matInput type="text" [value]="filter.domainName||''" placeholder="Search" [formControl]="nameCtrl">
              </mat-form-field>
            </div>

            <div class="mat-card-header-controls d-flex align-items-center">
              <cm-custom-upload-button-icon matTooltip="Upload data" (fileSelected)="uploadFile($event)" class="d-none d-md-block mr-2">
              </cm-custom-upload-button-icon>
              <button mat-icon-button color="primary" (click)="exportSites()" class="d-none d-md-block mr-2" matTooltip="Export">
                <i class="fas fa-download" aria-hidden="true"></i>
              </button>
              <button mat-icon-button color="primary" (click)="filters.toggle()" matTooltip="Filter">
                <i class="fas fa-filter" aria-hidden="true"></i>
              </button>

              <!--<div class="col-12 col-md-6 col-xl-auto d-none d-md-block text-md-right">-->
              <!--<button mat-raised-button color="white"-->
              <!--(click)="exportCsv()"-->
              <!--class="large iconed">-->
              <!--<i class="fas fa-download"></i>-->
              <!--Export to CSV-->
              <!--</button>-->
              <!--</div>-->
            </div>
          </div>

          <div class="cm-card-content">

            <cm-card-filters #filters>
              
              <div class="col col-auto d-md-none">
                <mat-form-field floatLabel="never" class="">
                  <input matInput type="text" [value]="filter.domainName||''" placeholder="Search" [formControl]="nameCtrl">
                </mat-form-field>
              </div>

              <div class="col col-auto">
                <mat-form-field floatLabel="never" class="">
                  <mat-select multiple [(ngModel)]="filter.status" placeholder="Filter by status" (selectionChange)="refreshDataFirstPage()">
                    <mat-option *ngFor="let s of DomainDpStatusKL" [value]="s.key">{{s.label}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </cm-card-filters>

            <div class="table-scroll-wrapper">
              <mat-table #table [dataSource]="dataSource" matSort matSortActive="createdOn" matSortDirection="desc">

                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                  <mat-header-cell *matHeaderCellDef class="d-none d-md-flex">
                    <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="d-none d-md-flex">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? toggle(row) : null" [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="url">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Site name / url</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Url:</span>
                    {{element.id.url }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="publisher">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Publisher</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{element.publisher}}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="submitted">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Submited</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{element.submitted ? 'YES': 'NO'}}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="adstxtStatus">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Ads.txt file</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="mat-cell--has-sort">
                    <span class="mobile-label">Ads.txt file:</span>
                    <cm-adstxt-status-icon [status]="element.adstxtStatus"></cm-adstxt-status-icon>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="status">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Domain status</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Domain status:</span>
                    <cm-domain-status-circle-plate [rejectReason]="element.rejectionReason" [status]="element.status"></cm-domain-status-circle-plate>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="createdOn">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Created on</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Created on:</span>
                    {{element.createdOn | date: 'yyyy-MM-dd'}}
                    <small>{{element.createdOn | date: 'hh:mm a'}}</small>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="lastUpdatedOn">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Updated on</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Updated on:</span>
                    {{element.lastUpdatedOn | date: 'yyyy-MM-dd'}}
                    <small>{{element.lastUpdatedOn | date: 'hh:mm a'}}</small>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef class="d-flex justify-content-center align-items-center">
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="d-flex justify-content-start align-items-center justify-content-center">
                    <button mat-icon-button disableRipple="true" *ngIf="element.status===DomainDpStatus.PENDING" [matMenuTriggerFor]="menu">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item (click)="approveSites([element])">
                        <i class="fas fa-check"></i>
                        <span>Approve</span>
                      </button>
                      <button mat-menu-item color="warn" (click)="rejectSites([element])">
                        <i class="far fa-trash-alt"></i>
                        <span>Reject</span>
                      </button>
                    </mat-menu>

                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns;"></mat-row>

              </mat-table>
            </div>
            <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20, 50]">
            </mat-paginator>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
